import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useConstantLengthInvariant, useArrayMapMemo } from "@contember/react-utils";
import { useCallback, useMemo } from "react";
import { throwBindingError } from "../BindingError.js";
import { SugaredField } from "./SugaredField.js";
import { Component } from "../coreComponents/Component.js";
import { useEntity } from "../accessorPropagation/useEntity.js";
import { QueryLanguage } from "../queryLanguage/QueryLanguage.js";
const FieldView = Component(
  (props) => {
    const { fallbackIfUnpersisted, render } = props;
    const fields = "fields" in props && Array.isArray(props.fields) ? props.fields : "field" in props && props.field ? [props.field] : throwBindingError(`FieldView: failed to supply either the 'field' or the 'fields' prop.`);
    useConstantLengthInvariant(
      fields,
      `The number of fields in the 'fields' prop of the 'FieldView' must remain constant between renders!`
    );
    const entityAccessor = useEntity();
    const environment = entityAccessor.environment;
    const desugarField = useCallback(
      (rsf) => QueryLanguage.desugarRelativeSingleField(rsf, environment),
      [environment]
    );
    const desugaredFields = useArrayMapMemo(fields, desugarField);
    const retrieveField = useCallback(
      (desugaredRsf) => entityAccessor.getRelativeSingleField(desugaredRsf),
      [entityAccessor]
    );
    const accessors = useArrayMapMemo(desugaredFields, retrieveField);
    const output = useMemo(() => {
      if (!entityAccessor.existsOnServer && fallbackIfUnpersisted !== void 0) {
        return fallbackIfUnpersisted;
      }
      return render(...accessors);
    }, [accessors, entityAccessor.existsOnServer, fallbackIfUnpersisted, render]);
    return /* @__PURE__ */ jsx(Fragment, { children: output });
  },
  (props) => {
    const fields = "fields" in props && Array.isArray(props.fields) ? props.fields : "field" in props && props.field ? [props.field] : throwBindingError(`FieldView: failed to supply either the 'field' or the 'fields' prop.`);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      props.fallbackIfUnpersisted,
      fields.map((field, i) => /* @__PURE__ */ jsx(SugaredField, { field }, i))
    ] });
  },
  "FieldView"
);
export {
  FieldView
};
//# sourceMappingURL=FieldView.js.map
